module.exports = __webpack_public_path__ + "img/shirt-long-sleeve.b3d2da90.svg";